import { Goal, IPossibleGoal } from "@raskrask-dk/raskrask-utils"


interface IGoalBFConstructor {
    icon?: string
    text?: string
}

export class GoalBF extends Goal {
    type = 'GoalBF'
    icon?: string
    text?: string

    constructor(goal: Goal, { icon, text }: IGoalBFConstructor) {
        super(goal.id, goal.name)
        this.icon = icon
        this.text = text
    }

    /**
     * Constructs a minimal goalBF.
     * This was created for mapping from IPossibleGoal
     */
    static fromPossibleGoal = (possibleGoal: IPossibleGoal): GoalBF => {
        const { goalId: id, goalName: name } = possibleGoal
        return new GoalBF(new Goal(id, name), {})
    }

    static fromGoals = (goals: Goal[]): GoalBF[] => {
        return goals.map((goal) => {
            const goalBF = new GoalBF(goal, {})
            goalBF.addServiceTypes(goal.services)
            return goalBF
        })
    }

    public get t() {
        return `common:goals.${this.id}`
    }
}
